class PDPUpsellSummary extends HTMLElement {
  constructor() {
    super();
    this.upsellProductElement = null;
    this.init();
  }

  init() {
    this.upsellProductElement = document.querySelector("pdp-upsell-product");

    if (!this.upsellProductElement) {
      console.warn("PDPUpsellProduct element not found");
      return;
    }

    const checkboxes = this.upsellProductElement.querySelectorAll(
      'input[type="checkbox"]'
    );
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.updateSummary.bind(this));
    });

    // Auf Hauptprodukt-Variantenwechsel reagieren
    document.addEventListener(
      "variant:change",
      this.handleMainVariantChange.bind(this)
    );
  }

  handleMainVariantChange(event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    // Hauptprodukt-Bild aktualisieren
    const mainImage = this.querySelector("[data-main-product-image]");
    if (mainImage && variant.featured_media) {
      mainImage.src = variant.featured_media.url || variant.featured_media.src;
      mainImage.alt = variant.featured_media.alt || variant.title;
    }

    // Hauptprodukt-Variantentitel aktualisieren
    const mainVariantTitle = this.querySelector("[data-main-variant-title]");
    if (mainVariantTitle) {
      mainVariantTitle.textContent = variant.title;
    }

    // Hauptprodukt-Preis aktualisieren
    const mainPrice = this.querySelector("[data-main-variant-price]");
    if (mainPrice && variant.price) {
      mainPrice.textContent = this.formatMoney(variant.price / 100);
    }

    // Hauptprodukt-Compare-Price aktualisieren oder erstellen
    let mainComparePrice = this.querySelector(
      "[data-main-variant-compare-price]"
    );

    if (variant.compare_at_price) {
      if (!mainComparePrice) {
        // Element existiert nicht → erstellen
        const pricesContainer = this.querySelector(
          "[data-main-product] .upsell-summary__item-prices"
        );
        if (pricesContainer) {
          mainComparePrice = document.createElement("div");
          mainComparePrice.className = "upsell-summary__item-compare-price";
          mainComparePrice.setAttribute("data-main-variant-compare-price", "");
          pricesContainer.appendChild(mainComparePrice);
        }
      }
      if (mainComparePrice) {
        mainComparePrice.textContent = this.formatMoney(
          variant.compare_at_price / 100
        );
        mainComparePrice.style.display = "";
      }
    } else if (mainComparePrice) {
      // Kein Compare-Price → ausblenden
      mainComparePrice.textContent = "";
      mainComparePrice.style.display = "none";
    }

    // Summary neu berechnen, wenn Upsells ausgewählt sind
    const hasCheckedUpsells =
      this.upsellProductElement.querySelectorAll(
        'input[type="checkbox"]:checked'
      ).length > 0;

    if (hasCheckedUpsells) {
      this.updateSummary();
    }
  }

  updateSummary() {
    const checkboxes = this.upsellProductElement.querySelectorAll(
      'input[type="checkbox"]:checked'
    );

    if (checkboxes.length === 0) {
      this.classList.remove("active");
      return;
    }

    this.classList.add("active");

    const selectedProducts = [];
    let totalOriginalPrice = 0;
    let totalCurrentPrice = 0;

    // Hauptprodukt-Preise einbeziehen
    const mainPriceEl = this.querySelector("[data-main-variant-price]");
    const mainComparePriceEl = this.querySelector(
      "[data-main-variant-compare-price]"
    );

    if (mainPriceEl) {
      const mainPrice = this.parsePrice(mainPriceEl.textContent.trim());
      totalCurrentPrice += mainPrice;
    }

    if (mainComparePriceEl) {
      const mainComparePrice = this.parsePrice(
        mainComparePriceEl.textContent.trim()
      );
      totalOriginalPrice += mainComparePrice;
    } else if (mainPriceEl) {
      // Wenn kein Compare-Price vorhanden, normalen Preis als Original verwenden
      const mainPrice = this.parsePrice(mainPriceEl.textContent.trim());
      totalOriginalPrice += mainPrice;
    }

    checkboxes.forEach((checkbox) => {
      const productItem = checkbox.closest(
        ".product-block--upsell-product-item"
      );
      if (!productItem) return;

      const image = productItem.querySelector(".upsell-product--image img");
      const productTitle = productItem.dataset.productTitle;
      const variantTitle = productItem.dataset.variantTitle;
      const priceEl = productItem.querySelector(".upsell-product--price");
      const comparePriceEl = productItem.querySelector(
        ".upsell-product--compare-price"
      );

      let priceText = "";
      let comparePriceText = "";
      let priceValue = 0;
      let comparePriceValue = 0;

      if (priceEl) {
        priceText = priceEl.textContent.trim();
        priceValue = this.parsePrice(priceText);
        totalCurrentPrice += priceValue;
      }

      if (comparePriceEl) {
        comparePriceText = comparePriceEl.textContent.trim();
        comparePriceValue = this.parsePrice(comparePriceText);
        totalOriginalPrice += comparePriceValue;
      } else if (priceEl) {
        // Wenn kein Compare-Price vorhanden, normalen Preis als Original verwenden
        totalOriginalPrice += priceValue;
      }

      if (image && productTitle) {
        selectedProducts.push({
          image: image.src,
          alt: image.alt,
          productTitle: productTitle,
          variantTitle: variantTitle,
          price: priceText,
          comparePrice: comparePriceText,
          variantId: checkbox.value,
        });
      }
    });

    this.renderSummary(selectedProducts, totalOriginalPrice, totalCurrentPrice);
  }

  renderSummary(products, originalPrice, currentPrice) {
    const discount = originalPrice - currentPrice;

    const discountEl = this.querySelector("[data-summary-discount]");
    if (discountEl && discount > 0) {
      discountEl.textContent = ` (-${this.formatMoney(discount)})`;
    }

    const originalPriceEl = this.querySelector("[data-summary-original-price]");
    if (originalPriceEl && originalPrice > 0) {
      originalPriceEl.textContent = this.formatMoney(originalPrice);
    }

    const currentPriceEl = this.querySelector("[data-summary-current-price]");
    if (currentPriceEl) {
      currentPriceEl.textContent = this.formatMoney(currentPrice);
    }

    const upsellItemsContainer = this.querySelector("[data-upsell-items]");
    if (upsellItemsContainer) {
      upsellItemsContainer.innerHTML = products
        .map(
          (product) => `
          <div class="upsell-summary__plus">+</div>
          <div class="upsell-summary__item">
            <div class="upsell-summary__item-image">
              <img src="${product.image}" alt="${
            product.alt || product.productTitle
          }" width="80" height="80">
            </div>
            <div class="upsell-summary__item-content">
              <div class="upsell-summary__item-title">${
                product.productTitle
              }</div>
              <div class="upsell-summary__item-variant">${
                product.variantTitle
              }</div>
            </div>
            <div class="upsell-summary__item-prices">
              <div class="upsell-summary__item-price sale-price">${
                product.price
              }</div>
              ${
                product.comparePrice
                  ? `<div class="upsell-summary__item-compare-price">${product.comparePrice}</div>`
                  : ""
              }
            </div>
          </div>
        `
        )
        .join("");
    }
  }

  parsePrice(priceText) {
    // Entfernt €-Zeichen und Tausenderpunkte, ersetzt Komma durch Punkt
    // Format: "1.299,00€" → "1299.00" → 1299.00
    const cleaned = priceText
      .replace(/€/g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    return parseFloat(cleaned) || 0;
  }

  formatMoney(amount) {
    const formatted = amount.toFixed(2);
    const [integer, decimal] = formatted.split(".");
    const integerWithSeparator = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${integerWithSeparator},${decimal}€`;
  }
}

if (!customElements.get("pdp-upsell-summary")) {
  customElements.define("pdp-upsell-summary", PDPUpsellSummary);
}
